import { CheckCircle2, Loader2, Save, TableProperties, X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

export interface StructuralExtractionHeaderProps {
  filename: string
  readOnly: boolean
  isGeospatial: boolean
  /** Whether the loaded scope has already been reviewed (readOnly mode). */
  reviewed: boolean
  /** Disable the Save & Mark as Reviewed action. */
  markDisabled: boolean
  marking: boolean
  onMarkReviewed: () => void
  onClose: () => void
}

/**
 * Pure modal header bar for the structural-extraction modal. Renders the title,
 * the readOnly "Save and Mark as Reviewed" action (or a Reviewed badge), and the
 * close button.
 */
export function StructuralExtractionHeader({
  filename,
  readOnly,
  isGeospatial,
  reviewed,
  markDisabled,
  marking,
  onMarkReviewed,
  onClose,
}: StructuralExtractionHeaderProps) {
  return (
    <div className="border-b shrink-0">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2 max-md:min-w-0 max-md:flex-1">
          <TableProperties className="h-4 w-4 text-muted-foreground max-md:shrink-0" />
          <h2 className="text-sm font-semibold truncate max-w-md max-md:min-w-0">
            {readOnly
              ? isGeospatial
                ? 'Geospatial Column Mapping — '
                : 'Tabular Extraction Scope — '
              : 'Structural Extraction Scope — '}
            {filename}
          </h2>
        </div>

        {readOnly ? (
          <div className="flex items-center gap-2 max-md:shrink-0">
            {reviewed ? (
              <Badge variant="secondary" className="flex items-center gap-1 text-xs">
                <CheckCircle2 className="h-3 w-3 text-success" />
                Reviewed
              </Badge>
            ) : (
              <Button
                variant="outline"
                size="sm"
                onClick={onMarkReviewed}
                disabled={markDisabled}
                className="h-7 text-xs"
              >
                {marking ? (
                  <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                ) : (
                  <Save className="h-3 w-3 mr-1" />
                )}
                Save and Mark as Reviewed
              </Button>
            )}

            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="h-7 w-7 p-0 max-md:size-9 max-md:shrink-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        ) : (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-7 w-7 p-0 max-md:size-9 max-md:shrink-0"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
